export default "__VITE_ASSET__BOdlfLr0__"